// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"53":"f6e232bb","78":"cb58ae08","227":"58cd3746","428":"cdf8a260","463":"46486f5c","488":"29b71886","735":"5353191f"}[chunkId] + ".chunk.js";
};